import { useQuery, useMutation } from '@apollo/client/react';
import { Visibility } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import { Grid } from '@mui/material';
import { EssealDataTable } from 'esseal-data-table';
import React, { useContext } from 'react';

import kickOffTemplatesColumns from '../GlobalSettingsSection/kickoffTemplatesColumns';

import CurrentUserContext from '@/Contexts/CurrentUser';
import {
  type KickOffTemplate,
  GetCompanyKickOffTemplatesDocument,
  DestroyKickOffTemplateDocument,
} from '@/graphql/generated/graphql';
import { displayNotification } from '@/utils/notifications';

const KickOffTemplatesSection: React.FC = () => {
  const { currentUser } = useContext(CurrentUserContext);

  const { data, loading } = useQuery(GetCompanyKickOffTemplatesDocument, {
    skip: !currentUser?.defaultCompany,
    fetchPolicy: 'cache-and-network',
  });

  const [destroyKickOffTemplate] = useMutation(DestroyKickOffTemplateDocument, {
    onCompleted: () => {
      displayNotification({ type: 'success', text: 'Kick-Off Template deleted successfully' });
    },
    refetchQueries: ['getCompanyKickOffTemplates'],
  });

  return (
    <React.Fragment>
      <Grid size={12}>
        <EssealDataTable
          rows={(data?.getCompanyKickOffTemplates as KickOffTemplate[]) || []}
          columns={kickOffTemplatesColumns}
          checkboxSelection={false}
          loading={loading}
          pagination={true}
          pageSize={25}
          // Actions & Events
          rowActions={(row) => [
            {
              label: 'View',
              icon: <Visibility fontSize="small" color="primary" />,
              tooltip: 'Show Template',
              onClick: () => {},
            },
            {
              label: 'Edit',
              icon: <EditIcon fontSize="small" color="primary" />,
              tooltip: 'Edit Template',
              onClick: () => {},
            },
            {
              label: 'Share',
              icon: <SendIcon fontSize="small" color="disabled" />,
              tooltip: 'Future Sharing Feature',
              onClick: () => {},
              disabled: true,
            },
            {
              label: 'Delete',
              icon: <DeleteIcon fontSize="small" color="primary" />,
              tooltip: 'Delete Template',
              onClick: () =>
                destroyKickOffTemplate({
                  variables: { id: row.id },
                }),
            },
          ]}
        />
      </Grid>
      {/* 
      {(showTemplate && !isNull(selectedTemplate)) &&
        <ShowTemplateModal template={selectedTemplate} handleClose={() => { setShowTemplate(false); setSelectedTemplate(null); }} />
      }

      {showShareTemplate && !isNull(selectedTemplate) &&
        <ShareTemplateModal template={selectedTemplate} handleClose={() => { setShowShareTemplate(false); setSelectedTemplate(null); }} />
      }

      {(showEditTemplate && !isNull(selectedTemplate)) &&
        <EditTemplateModal template={selectedTemplate} handleClose={() => { setShowEditTemplate(false); setSelectedTemplate(null); }} />
      } */}
    </React.Fragment>
  );
};

export default KickOffTemplatesSection;
